// extracted by mini-css-extract-plugin
module.exports = {"avatar":"sq2opq","noSrc":"_19d_LH","circle":"_3CNjmM"};